import type { UserData } from "../hooks/useUserData";
import { isPhoneNumberStub } from "./phoneNumber";

export function getUserProfileCompleteness(
  userData: UserData | null | undefined,
) {
  const hasPhonenumber =
    userData?.phonenumber != null &&
    userData.phonenumber.trim() !== "" &&
    !isPhoneNumberStub(userData.phonenumber.trim());
  const hasFirstName = !!userData?.firstName?.trim();
  const hasLastName = !!userData?.lastName?.trim();
  const hasEmail = !!userData?.email?.trim();
  const isProfileComplete =
    hasPhonenumber && hasFirstName && hasLastName && hasEmail;

  return { hasPhonenumber, hasFirstName, hasLastName, hasEmail, isProfileComplete };
}
